// Description: Endpoint to fetch the campaigns summary
// Updated:
// Author: Simon Franklin

import use123zapStore from "../../../context/123zapStore";
import { getTokenData } from "../../../shared/utils/utils";

export const CampaignsSummary = async (requestBody) => {

    try {
        const url = process.env.REACT_APP_BACKEND_AWS_URL;

        const { token, client_id } = await getTokenData();

        if (!token) {
            throw new Error('Token de autenticação não encontrado');
        }

        if (!client_id) {
            throw new Error('ID do cliente não encontrado');
        }

        const response = await fetch(`${url}/dashboard/campaigns/summary`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token,
                "Client_ID": client_id
            },
            body: JSON.stringify(requestBody)
        });

        const data = await response.json();

        return data;

    } catch (error) {
        console.error('Erro ao buscar dados do gráfico:', error.message);
    }
}